import { Button } from "common/src/styles";
import { getTimeLeft, isInfiniteDate, parseTimeLeftString } from "../api/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateCountdownString = targetDate => {
  if (!targetDate) return undefined;
  const targetDateString = Math.round(targetDate.getTime() / 1000).toString();
  const timeLeft = getTimeLeft(targetDateString);
  const timeLeftString = parseTimeLeftString(timeLeft);
  return timeLeftString;
};
const generateBannerString = (status, targetDate) => {
  switch (status) {
    case "pre-application":
      return `Applications open in ${generateCountdownString(targetDate)}!`;
    case "during-application":
      return targetDate === undefined || isInfiniteDate(targetDate) ? "Applications are open" : `Applications close in ${generateCountdownString(targetDate)}!`;
    case "post-application":
      return `Applications are closed`;
    default:
      throw new Error("Unknown ApplicationPeriodStatus");
  }
};
function ApplicationsCountdownBanner(props) {
  const {
    startDate,
    endDate,
    applicationURL
  } = props;
  let targetDate = undefined;
  let status = "post-application";
  const currentTime = new Date();
  const isBeforeApplicationPeriod = currentTime < startDate;
  const isDuringApplicationPeriod = isInfiniteDate(endDate) || currentTime >= startDate && currentTime < endDate;
  if (isDuringApplicationPeriod) {
    targetDate = endDate;
    status = "during-application";
  } else if (isBeforeApplicationPeriod) {
    targetDate = startDate;
    status = "pre-application";
  }
  const bannerString = generateBannerString(status, targetDate);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center bg-grey-50 w-fit py-6 px-36 rounded-2xl",
    children: [/*#__PURE__*/_jsx("p", {
      children: bannerString
    }), /*#__PURE__*/_jsx(ApplyButton, {
      status: status,
      applicationURL: applicationURL
    })]
  });
}
const ApplyButton = props => {
  const {
    status,
    applicationURL
  } = props;
  return /*#__PURE__*/_jsx(Button, {
    type: "button",
    onClick: () => window.open(applicationURL, "_blank"),
    className: "bg-orange-100 text-grey-500 mt-2 basis-full items-center justify-center shadow-sm text-sm rounded md:h-12",
    "data-testid": status === "during-application" ? "apply-button" : "view-requirements-button",
    children: status === "during-application" ? "Apply now!" : "Check requirements"
  });
};
export default ApplicationsCountdownBanner;